import yup from '../yup-extended';
import { LegalType, Salutation } from '@cobra/interfaces-enums-mocks/enums';

/*
 * Person
 * */
export const salutationSchema = yup.string().nullable().trim().label('Anrede').optionalOneOf(Object.values(Salutation));
export const titleSchema = yup.string().nullable().trim().label('Titel').max(50);
export const firstNameSchema = yup.string().nullable().trim().label('Vorname').max(30);
export const lastNameSchema = yup.string().nullable().trim().label('Nachname').max(40);

export const dependentFirstAndLastNameSchema = yup.object().shape(
    {
        firstName: firstNameSchema.when('lastName', {
            is: (value) => value?.trim() !== '',
            then: (schema) => schema.required(),
        }),
        lastName: lastNameSchema.when('firstName', {
            is: (value) => value?.trim() !== '',
            then: (schema) => schema.required(),
        }),
    },
    [['firstName', 'lastName']]
);

export const privateLegalTypeSchema = yup.string().nullable().trim().optionalOneOf([LegalType.PRIVATE]);
export const businessLegalTypeSchema = yup.string().nullable().trim().optionalOneOf([LegalType.BUSINESS]);
export const legalTypeSchema = yup.string().nullable().trim().optionalOneOf([LegalType.BUSINESS, LegalType.PRIVATE]);
